// extracted by mini-css-extract-plugin
export default {"card":"CardVisitas_card__ExPid","container":"CardVisitas_container__keVxR"};